import { render } from "./PasswordReset.vue?vue&type=template&id=689b283f"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"
script.render = render

export default script